export const isBrowser = typeof document !== "undefined";
